export default {
    English: [
        'What is your favorite vacation spot?',
        'In what city did you first meet your spouse?',
        'What country would you most like to visit?',
        'What is the title of your favorite book?',
        'What is the name of the first street you lived on?',
        'What was the name of your first pet?',
        "What is your best friend's last name?",
    ],
    Spanish: [
        '¿Cuál es su lugar favorito para vacacionar?',
        '¿En qué cuidad conoció primero usted a su cónyuge?',
        '¿Que país le gustaría visitar?',
        '¿Cuál es el título de su libro favorito?',
        '¿Cuál es el nombre de la primera calle en la que usted vivió?',
        '¿Cuál era el nombre de su primer animal doméstico?',
        '¿Cuál es el apellido de su mejor amigo(a)?',
    ],
};